import AttachmentsList from './attachments-list';

export default AttachmentsList;